import { FunctionComponent, useCallback, useState } from "react";
import { MenuItem } from "./MenuItem";
import { ClientLink } from "@dto/ClientLink";
import { LinkModal } from "../../components/LinkModal/LinkModal";
interface ClientLinkMenuItemProps {
  clientLink: ClientLink;
}

export const ClientLinkMenuItem: FunctionComponent<ClientLinkMenuItemProps> = ({
  clientLink,
}) => {
  const { label, url, icon3xUrl } = clientLink;
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = useCallback(() => setIsOpen(false), []);
  const handleOpen = useCallback((event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setIsOpen(true);
  }, []);

  return (
    <>
      <LinkModal open={isOpen} onClose={handleClose} url={url} title={label} />
      <MenuItem
        inactiveIconUrl={icon3xUrl}
        activeIconUrl={icon3xUrl}
        handlePress={handleOpen}
        label={label}>
        <a href={url} title={`Navigate to ${label}`} onClick={handleOpen}>
          {label}
        </a>
      </MenuItem>
    </>
  );
};
